module.exports = {
  "time-dot-wrap": {
    "flexDirection": "row",
    "alignItems": "center"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-cb776d64!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-countdown/index.vue
// module id = 547
// module chunks = 0 1